import { type QueryHookOptions, useQuery } from "@apollo/client";
import { PromocodeQuery } from "../graphql/queries";
import type {
  PromocodeQueryType,
  PromocodeQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const usePromocodeQuery = (
  options?: QueryHookOptions<PromocodeQueryType, PromocodeQueryVariablesType>
) => {
  return useQuery<PromocodeQueryType, PromocodeQueryVariablesType>(
    PromocodeQuery,
    options
  );
};
